import Core from '@mediaplatform/sportal365-tennis-sdk';

// Types
import { TennisSDKOptions } from '../types/tennis';

export default ({
  dataConfigApiUrl,
  dataConfigApiKey,
  dataConfigLang,
  dataConfigProject,
  dataConfigOddClient,
  dataConfigTimezone,
  dataConfigCompetitionList,
  dataConfigPlayoffApiUrl,
  dataConfigStandingsApiUrl,
}: TennisSDKOptions) => {
  return new Core({
    dataConfigApiUrl: dataConfigApiUrl,
    dataConfigApiKey: dataConfigApiKey,
    dataConfigLang: dataConfigLang,
    dataConfigProject: dataConfigProject,
    dataConfigOddClient: dataConfigOddClient,
    dataConfigTimezone: dataConfigTimezone,
    dataConfigCompetitionList: dataConfigCompetitionList,
    dataConfigPlayoffApiUrl: dataConfigPlayoffApiUrl,
    dataConfigStandingsApiUrl: dataConfigStandingsApiUrl,
  });
};
